import { render } from "./ScheduledPushNotification.vue?vue&type=template&id=2d1157b2&scoped=true"
import script from "./ScheduledPushNotification.vue?vue&type=script&lang=js"
export * from "./ScheduledPushNotification.vue?vue&type=script&lang=js"

import "./ScheduledPushNotification.vue?vue&type=style&index=0&id=2d1157b2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1157b2"]])

export default __exports__